
import React, { useState } from 'react';
import './Quantity.css';

const QuantitySelector = ({ min = 1, max = 10, initial = 1 }) => {
  const [quantity, setQuantity] = useState(initial);

  const increment = () => {
    if (quantity < max) setQuantity(quantity + 1);
  };

  const decrement = () => {
    if (quantity > min) setQuantity(quantity - 1);
  };

  return (
    <div className="quantity-selector">
      <button className="quantity-btn" onClick={decrement} disabled={quantity <= min}>
        -
      </button>
      <input
        type="text"
        value={quantity}
        readOnly
        className="quantity-input"
      />
      <button className="quantity-btn" onClick={increment} disabled={quantity >= max}>
        +
      </button>
    </div>
  );
};

export default QuantitySelector;
